// extracted by mini-css-extract-plugin
export var borderRadius = "_fh-4";
export var large = "_fh-3";
export var logoContainer = "_fh-0";
export var nameLogo = "_fh-2";
export var small = "_fh-1";